var e4 = e4 || {},
    dcc = dcc || {};
( function () {
    dcc.configurator = {
        productId: function () {
            return jQuery( dcc.configurator.selectors.main ).data( 'productId' );
        },
        states: {
            config: 'configuration',
            cart: 'cart',
            qty: 'qty'
        },
        constants: {
            supportPrice: 'supportPrice',
            combinedSupportPrice: 'combinedSupportPrice',
            keyboardsInternal: 'keyboardsinternal',
            oslanguage: 'oslanguage',
            warranty: 'Warranty',
            osOtherLang: 'OSLOther',
            nothingSelected: 'NOTHINGSELECTED',
            autopilotCheckedOrderlineFieldSystemName: 'Autopilot',
            autopilotEmailOrderlineFieldSystemName: 'AutopilotEmail'
        },
        selectors: {
            main: '.js-dcc-main-product',
            section: '.js-dcc-configurator-section',
            trigger: '.js-dcc-configurator-open',
            close: '.js-dcc-configurator-close',
            loader: '.js-dcc-configurator-loading-overlay',
            partInput: '.js-dcc-configurator-part-input',
            partInputLanguage: '.js-dcc-configurator-part-input-language',
            partOsLanguageInput: '.js-dcc-configurator-input-os-language',
            partInputNone: '.js-dcc-configurator-part-input-none',
            partSelect: '.js-dcc-configurator-category-item-language-select',
            partIdDefault: '.js-dcc-configurator-part-diff-default',
            reminder: '.js-dcc-configurator-reminder',
            dynamicValueInput: '.js-dcc-configurator-dynamic-value',
            diffPrice: '.js-dcc-configurator-part-price-diff',
            diffPriceKeyboard: '.js-dcc-configurator-part-keyboard-price-diff',
            categoryContainer: '.js-dcc-configurator-category',
            categoryItem: '.js-dcc-configurator-category-item',
            partsContainer: '.js-dcc-configurator-parts',
            overview: '.js-dcc-configurator-overview',
            overviewContainer: '.js-dcc-configurator-overview-container',
            overviewCalculatedPrice: '.js-dcc-configurator-overview-price-configured',
            mobileHandle: '.js-dcc-configurator-overview-mobile-handle',
            mobileHandlerPrice: '.js-dcc-configurator-overview-mobile-handle-price',
            cartContainer: '.js-dcc-configurator-cart-container',
            cartRelatedContainer: '.js-dcc-configurator-cart-related-products-container',
            relatedProducts: '.js-dcc-section-related-products',
            quantity: '.js-dcc-configurator-quantity',
            form: '.js-dcc-configurator-configuration-form',
            hasConfiguration: '.js-dcc-configurator-overview-has-configuration',
            warranty: {
                input: '.js-dcc-configurator-overview-warranty-input',
                orderLineField: '.js-dcc-configurator-overview-warranty-orderline-field',
                collapse: '.js-dcc-configurator-overview-warranty-collapse'
            },
            leasing: {
                checkbox: '.js-dcc-configurator-overview-leasing-checkbox',
                selectRate: '.js-dcc-configurator-overview-leasing-interest-rate',
                inputRate: '.js-dcc-configurator-overview-leasing-input-rate',
                checked: '.js-dcc-configurator-overview-leasing-checked',
                price: '.js-dcc-configurator-overview-leasing-price',
                collapse: '.js-dcc-configurator-overview-leasing-collapse'
            },
            autopilot: {
                checkbox: '.js-dcc-configurator-overview-autopilot-checkbox',
                collapse: '.js-dcc-configurator-overview-autopilot-collapse',
                checked: '.js-dcc-configurator-overview-autopilot-checked',
                email: '.js-dcc-configurator-overview-autopilot-email',
                emailValue: '.js-dcc-configurator-autopilot-email-value',
            },
            disableElements: '.js-dcc-configurator-disabled-element',
            sectionCollapseContent: '.p-section-collapse-content',
            productlistLink: '.js-dcc-itemlist-icon-configurable',
            cssUtils: {
                isLoading: 'is-loading',
                hide: 'd-none',
                below: 'below',
                above: 'above',
                open: 'open',
                disabledForm: 'disabled-form',
                totalCollapse: 'dcc-configurator-total-collapse'
            }
        },
        templates: [
            '#js-e-handlebars-tmpl-configurator-parts',
            '#js-e-handlebars-tmpl-configurator-overview',
            '#js-e-handlebars-tmpl-configurator-cart'
        ],
        helpers: [
            'compare',
            'compare_extended',
            'counter',
            'compareLength',
            'isNotDefaultPartInCategory',
            'hasCategories',
            'getCustomOsLanguagePartName',
            'filterKeyboardLanguages',
            'filterConfigurationParts',
            'getKeyboardDiffPrice'
        ],
        events: [
            'domready',
            'dataready',
            'stateready',
            'configurationchanged',
            'listbuild',
            'overviewbuild',
            'addtocart'
        ],
        init: function () {
            if ( jQuery( dcc.configurator.selectors.section ).length === 1 ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( dcc.configurator.templates.join( ' ' ) );
                    e4.handlebars.registerHelpers( dcc.configurator.helpers.join( ' ' ) );
                    dcc.configurator.bindEvents();
                    dcc.configurator.data.init();
                    if ( e4.util.hash.get( dcc.configurator.states.qty ) ) {
                        jQuery( '.js-e-product-form' ).find( 'input[name="Quantity"]' ).val( e4.util.hash.get( dcc.configurator.states.qty ) ).trigger( 'input' );
                    }
                } );
                dcc.configurator.event = e4.util.registerEvents( dcc.configurator.events.join( ' ' ), 'configurator' );
            }
            else {
                dcc.configurator.bindExternalEvents();
            }
            dcc.configurator.utils.loader( false );
        },
        bindExternalEvents: function () {
            jQuery( '.js-e-productlist' ).on( 'click', dcc.configurator.selectors.productlistLink, function () {
                location.href = jQuery( this ).data( 'href' );
            } );
            jQuery( document ).on( 'input', '.js-e-products-item input[name^="Quantity"]', function ( event ) {
                var productItem = jQuery( event.target ).closest( '.js-e-products-item' ),
                    configuratorLink = productItem.find( '.js-dcc-configurator-open' ),
                    hrefSplit = jQuery( configuratorLink ).attr( 'href' ).split( '#' ),
                    href = hrefSplit[ 0 ] + '#/qty=' + event.target.value + '&' + hrefSplit[ 1 ].replace( '/', '' );
                jQuery( configuratorLink ).attr( 'href', href );
            } );
        },
        bindEvents: function () {
            jQuery( dcc.configurator.selectors.trigger ).on( 'click', function () {
                dcc.configurator.utils.tabs( 'dcc-productpage-tab-config', true );
            } );
            jQuery('.js-dcc-configurator-anchor-link').on('click', function(){
                dcc.configurator.utils.tabs( 'dcc-productpage-tab-config', true );
            });
            
            jQuery( '.js-e-product-form' ).on( 'input', 'input[name="Quantity"]', function () {
                dcc.configurator.overview.build( null, true );
            } ).on( 'click', '.js-dcc-add-configuration-to-cart-from-main', function ( event ) {
                if ( dcc.configurator.data.configuration.hasConfiguration ) {
                    event.preventDefault();
                    jQuery( dcc.configurator.selectors.form ).trigger( 'submit' );
                }
            } );
            jQuery( '.js-dcc-productpage-tab' ).on( 'shown.bs.tab', function ( event ) {
                dcc.configurator.utils.tabs( event.target.id, event.target.id === 'dcc-productpage-tab-config' );
            } );
            /* List events */
            jQuery( dcc.configurator.selectors.partsContainer ).on( 'change', dcc.configurator.selectors.partInput, function ( event ) {
                if ( jQuery( event.target ).data( 'category' ) === dcc.configurator.constants.keyboardsInternal && jQuery( event.target ).is( dcc.configurator.selectors.partInputLanguage ) === false ) {
                    jQuery( dcc.configurator.selectors.partSelect ).find( 'option.js-dcc-is-default-keyboard-language' ).prop( 'selected', true );
                }
                if ( jQuery( event.target ).data( 'category' ) === dcc.configurator.constants.oslanguage && jQuery( event.target ).is( dcc.configurator.selectors.partInputLanguage ) === false ) {
                    jQuery( dcc.configurator.selectors.partOsLanguageInput ).val( '' );
                }
                jQuery( dcc.configurator.selectors.section ).trigger( dcc.configurator.event.configurationchanged, [ event.target ] );
            } ).on( 'change', dcc.configurator.selectors.partSelect, function ( event ) {
                var defaultLang = dcc.configurator.utils.getDefaultLanguagePartObj();
                dcc.configurator.overview.price.updateKeyboardPrice( event.target );
                if ( defaultLang && event.target.value === defaultLang.id ) {
                    jQuery( event.target ).closest( dcc.configurator.selectors.categoryContainer ).find( dcc.configurator.selectors.partInput ).first().prop( 'checked', true ).trigger( 'change' );
                }
                else {
                    jQuery( event.target ).closest( dcc.configurator.selectors.categoryItem ).find( dcc.configurator.selectors.partInput ).prop( 'checked', true ).trigger( 'change' );
                }
                if ( event.target.value === 'PROD1' ) {
                    jQuery( event.target ).closest( dcc.configurator.selectors.categoryContainer ).find( dcc.configurator.selectors.partInput ).first().prop( 'checked', true ).trigger( 'change' );
                }
            } ).on( 'focus', dcc.configurator.selectors.partOsLanguageInput, function ( event ) {
                if ( jQuery( event.target ).closest( dcc.configurator.selectors.categoryItem ).find( dcc.configurator.selectors.partInput ).is( ':checked' ) === false ) {
                    jQuery( event.target ).closest( dcc.configurator.selectors.categoryItem ).find( dcc.configurator.selectors.partInput ).prop( 'checked', true ).trigger( 'change' );
                }
            } ).on( 'input', dcc.configurator.selectors.partOsLanguageInput, function ( event ) {
                jQuery( '.js-dcc-configurator-overview-custom-os-language-label' ).text( event.target.value );
                jQuery( '.js-dcc-configurator-overview-custom-os-language' ).val( event.target.value );
            } ).on( 'change', dcc.configurator.selectors.warranty.input, function ( event ) {
                dcc.configurator.overview.warranty.update( event.target );
                dcc.configurator.overview.update();
            } ).on( 'hidden.bs.collapse', dcc.configurator.selectors.warranty.collapse, function () {
                dcc.configurator.overview.warranty.isOpen = false;
            } ).on( 'shown.bs.collapse', dcc.configurator.selectors.warranty.collapse, function () {
                dcc.configurator.overview.warranty.isOpen = true;
            } );
            /* Overview events */
            jQuery( dcc.configurator.selectors.overviewContainer ).on( 'change', dcc.configurator.selectors.leasing.checkbox, function () {
                dcc.configurator.overview.leasing.offer();
            } ).on( 'change', dcc.configurator.selectors.leasing.selectRate, function () {
                dcc.configurator.overview.leasing.price();
            } ).on( 'hidden.bs.collapse', dcc.configurator.selectors.leasing.collapse, function () {
                dcc.configurator.overview.leasing.model.open = false;
                dcc.configurator.overview.leasing.update();
            } ).on( 'shown.bs.collapse', dcc.configurator.selectors.leasing.collapse, function () {
                dcc.configurator.overview.leasing.model.open = true;
                dcc.configurator.overview.leasing.update();
            } ).on('change', dcc.configurator.selectors.autopilot.checkbox, function(event){
                jQuery('.js-dcc-autopilot-checkbox').prop('checked', event.target.checked).trigger('change');
                dcc.configurator.overview.autopilot.update(event.target.checked);
            }).on('hidden.bs.collapse', dcc.configurator.selectors.autopilot.collapse, function(event){
                dcc.configurator.overview.autopilot.model.open = false;
            }).on('shown.bs.collapse', dcc.configurator.selectors.autopilot.collapse, function(event){
                dcc.configurator.overview.autopilot.model.open = true;
            }).on('input', dcc.configurator.selectors.autopilot.emailValue, function(event){
                dcc.configurator.selectors.autopilot.email = event.target.value;
            });
            /* Mobile events */
            jQuery( dcc.configurator.selectors.section ).on( 'click', dcc.configurator.selectors.mobileHandle, function () {
                dcc.configurator.overview.mobile.toggle();
            } );
            /* Cart events */
            jQuery( dcc.configurator.selectors.overview ).on( 'submit', dcc.configurator.selectors.form, function ( event ) {
                event.preventDefault();
                if ( dcc.configurator.data.configuration.isEditing === true ) {
                    dcc.configurator.overview.cart.update( dcc.configurator.editConfiguration.orderlineId );
                }
                else {
                    dcc.configurator.overview.cart.add();
                }
            } );
            /* Window events */
            jQuery( window ).on( 'hashchange', function () {
                dcc.configurator.observers.statesObserver();
            } );
            /* Custom events */
            jQuery( dcc.configurator.selectors.section ).on( 'dataready.e4.configurator', function () {
                dcc.configurator.list.init();
            } ).on( 'domready.e4.configurator', function () {
                dcc.configurator.observers.statesObserver();
                dcc.configurator.utils.loader( false );
            } ).on( 'listbuild.e4.configurator', function () {
                dcc.configurator.overview.init();
            } ).on( 'stateready.e4.configurator', function () {
                dcc.configurator.editConfiguration.init();
            } ).on( 'configurationchanged.e4.configurator', function ( event, domElm ) {
                dcc.configurator.data.configuration.hasChanged = true;
                dcc.configurator.observers.configurationObserver( domElm );
                dcc.configurator.overview.update();
                dcc.configurator.list.priceDiff.update( domElm );
            } );
            /*
             var observerElements = jQuery( dcc.configurator.selectors.section ).toArray();
             e4.util.observer.bind( observerElements, dcc.configurator.utils.reminder );
             */
        },
        utils: {
            loader: function ( boolShow ) {
                if ( boolShow === true ) {
                    jQuery( dcc.configurator.selectors.loader ).addClass( dcc.configurator.selectors.cssUtils.isLoading );
                }
                else {
                    jQuery( dcc.configurator.selectors.loader ).removeClass( dcc.configurator.selectors.cssUtils.isLoading );
                }
            },
            reminder: function ( domElm ) {
                if ( e4.util.hash.get( 'state' ) === dcc.configurator.states.config ) {
                    if ( domElm.isIntersecting === false ) {
                        jQuery( dcc.configurator.selectors.reminder ).removeClass( dcc.configurator.selectors.cssUtils.hide );
                        if ( domElm.boundingClientRect.top > 0 ) {
                            jQuery( dcc.configurator.selectors.reminder ).addClass( dcc.configurator.selectors.cssUtils.below );
                        }
                        else {
                            jQuery( dcc.configurator.selectors.reminder ).addClass( dcc.configurator.selectors.cssUtils.above );
                        }
                    }
                    else {
                        jQuery( dcc.configurator.selectors.reminder ).removeClass( dcc.configurator.selectors.cssUtils.below + ' ' + dcc.configurator.selectors.cssUtils.above );
                        jQuery( dcc.configurator.selectors.reminder ).addClass( dcc.configurator.selectors.cssUtils.hide );
                    }
                }
            },
            tabs: function ( id, isConfig ) {
                var intScrollTarget = e4.scrollToAnchor.getTarget( '#' + id );
                if ( isConfig === true ) {
                    jQuery( '#' + id ).tab( 'show' );
                    e4.util.hash.set( 'state', dcc.configurator.states.config );
                    /*
                     jQuery( 'html,body' ).animate( {
                     scrollTop: intScrollTarget
                     }, Math.floor( Math.abs( jQuery( window ).scrollTop() - intScrollTarget ) * e4.settings.scrollToAnchor.speed ), e4.settings.scrollToAnchor.easing, function () {
                     e4.header.hide();
                     jQuery( '#' + id ).tab( 'show' );
                     jQuery( dcc.configurator.selectors.disableElements ).addClass( dcc.configurator.selectors.cssUtils.disabledForm );
                     e4.util.hash.set( 'state', dcc.configurator.states.config );
                     } );
                     */
                }
                else {
                    if ( e4.util.hash.get( 'state' ) === dcc.configurator.states.cart ) {
                        jQuery( 'html,body' ).animate( {
                            scrollTop: intScrollTarget
                        }, Math.floor( Math.abs( jQuery( window ).scrollTop() - intScrollTarget ) * e4.settings.scrollToAnchor.speed ), e4.settings.scrollToAnchor.easing, function () {
                            e4.header.hide();
                            jQuery( '#' + id ).tab( 'show' );
                        } );
                    }
                    jQuery( dcc.configurator.selectors.disableElements ).removeClass( dcc.configurator.selectors.cssUtils.disabledForm );
                    history.pushState( '', document.title, window.location.pathname + window.location.search );
                    e4.util.hash.remove( 'state' );
                }
            },
            getUrlParams: function () {
                var params = {};
                if ( location.search.substring( 1 ).length > 0 ) {
                    var paramGroups = location.search.substring( 1 ).split( '&' );
                    for ( var i = 0; i < paramGroups.length; i++ ) {
                        var urlParamPair = paramGroups[ i ].split( '=' );
                        params[ urlParamPair[ 0 ] ] = urlParamPair[ 1 ];
                    }
                }
                return params;
            },
            removeUrlParam: function ( parameter ) {
                var url = location.href;
                var urlparts = url.split( '?' );
                if ( urlparts.length >= 2 ) {
                    var prefix = encodeURIComponent( parameter ) + '=';
                    var pars = urlparts[ 1 ].split( /[&;]/g );
                    //reverse iteration as may be destructive
                    for ( var i = pars.length; i-- > 0; ) {
                        //idiom for string.startsWith
                        if ( pars[ i ].lastIndexOf( prefix, 0 ) !== -1 ) {
                            pars.splice( i, 1 );
                        }
                    }
                    url = urlparts[ 0 ] + '?' + pars.join( '&' );
                    return url;
                }
                else {
                    return url;
                }
            },
            getPartDefaultConfiguration: function ( domCategory ) {
                var returnValue = '',
                    jInputDefaultValue = jQuery( domCategory ).find( dcc.configurator.selectors.partInput ).filter( '[data-default-configuration]' ).data( 'defaultConfiguration' );
                if ( jInputDefaultValue === undefined ) {
                    returnValue = jQuery( domCategory ).find( dcc.configurator.selectors.partSelect + ' option' ).filter( '[class="js-dcc-is-default-keyboard-language"]' ).val();
                }
                else {
                    returnValue = jInputDefaultValue;
                }
                return returnValue;
            },
            getPartRAM: function ( domCategory ) {
                var intPartRam = jQuery( domCategory ).find( dcc.configurator.selectors.partInput ).filter( '[data-ram]' ).filter( ':checked' ).data( 'ram' );
                if ( intPartRam === undefined ) {
                    return;
                }
                return {
                    partRam: intPartRam,
                    maxRam: jQuery( domCategory ).find( dcc.configurator.selectors.partInput ).filter( '[data-max-ram-supported]' ).data( 'maxRamSupported' )
                };
            },
            getPartConfiguration: function ( domCategory ) {
                var returnValue = '',
                    jInput = jQuery( domCategory ).find( dcc.configurator.selectors.partInput ),
                    jSelect = jQuery( domCategory ).find( dcc.configurator.selectors.partSelect );
                if ( jSelect.val() !== undefined ) {
                    returnValue = jSelect.val();
                }
                else {
                    returnValue = jInput.filter( ':checked' ).val();
                }
                return returnValue;
            },
            getSelectedParts: function () {
                return jQuery( dcc.configurator.selectors.partInput ).filter( ':checked' );
            },
            getCategoryObj: function ( strCategoryKey ) {
                return dcc.configurator.data.json.configurables[ strCategoryKey ];
            },
            getPartObj: function ( partCategory, partId ) {
                var returnObj = dcc.configurator.data.json.configurables[ partCategory ].parts.filter( function ( obj ) {
                    return obj.id === partId;
                } );
                return returnObj[ 0 ];
            },
            getLanguagePartObj: function ( partCategory, selectedLanguageProductId ) {
                var returnObj = dcc.configurator.data.json.configurables[ partCategory ].languageParts.filter( function ( obj ) {
                    return obj.id === selectedLanguageProductId;
                } );
                return returnObj[ 0 ];
            },
            getDefaultLanguagePartObj: function () {
                var returnObj = dcc.configurator.data.json.configurables.keyboardsinternal.parts[ 0 ].languages.filter( function ( langObj ) {
                    return langObj.isDefault === true;
                } );
                if ( returnObj.length === 0 ) {
                    returnObj = dcc.configurator.data.json.configurables.keyboardsinternal.parts[ 0 ].languages.filter( function ( langObj ) {
                        return langObj.id === 'PROD1';
                    } );
                }
                //console.log(returnObj);
                return returnObj[ 0 ];
            },
            getSelectedWarranty: function () {
                var jSelectedWarranty = jQuery( dcc.configurator.selectors.warranty.input ).filter( ':checked' ),
                    strSelectedProductId = jSelectedWarranty.val(),
                    returnObj = dcc.configurator.data.json.warrantyRelatedProducts.filter( function ( obj ) {
                        return obj.id === strSelectedProductId;
                    } );
                return returnObj[ 0 ];
            },
            getSelectedRAMSlots: function () {
                var selectedRamArr = [];
                jQuery( dcc.configurator.selectors.categoryContainer ).filter( '[data-slot="MEMORY"]' ).each( function ( categoryIndex, category ) {
                    jQuery( category ).find( dcc.configurator.selectors.partInput ).filter( ':checked' ).each( function ( partIndex, domInput ) {
                        if ( jQuery( domInput ).data( 'ram' ) ) {
                            selectedRamArr.push( jQuery( domInput ).data( 'ram' ) );
                        }
                    } );
                } );
                return selectedRamArr;
            },
            sortByDefault: function ( arrToSort ) {
                var returnArrToSort = arrToSort.sort( function ( a, b ) {
                    return ( a.isDefault === b.isDefault ) ? 0 : a.isDefault ? -1 : 1;
                } );
                var otherLanguagePlaceholder = {};
                for ( var i = 0; i < returnArrToSort.length; i++ ) {
                    if ( returnArrToSort[ i ].number === dcc.configurator.constants.osOtherLang ) {
                        otherLanguagePlaceholder = returnArrToSort[ i ];
                        returnArrToSort.splice( i, 1 );
                    }
                }
                if ( Object.keys( otherLanguagePlaceholder ).length > 0 ) {
                    returnArrToSort.push( otherLanguagePlaceholder );
                }
                return returnArrToSort;
            },
            sortByStock: function ( arrToSort ) {
                return arrToSort.sort( function ( a, b ) {
                    return parseInt( b.stock ) - parseInt( a.stock );
                } );
            },
            sortPartsByPrice: function ( arrParts ) {
                var returnParts = arrParts;
                if ( arrParts.length > 1 ) {
                    returnParts = arrParts.sort( function ( a, b ) {
                        return b.price - a.price;
                    } );
                }
                return returnParts;
            },
            cleanupConfigurationGroups: function () {
                jQuery.each( dcc.configurator.data.json.configurables, function ( strKey, arrGroup ) {
                    var objGroup = arrGroup[ 0 ];
                    dcc.configurator.data.json.configurables[ strKey ] = objGroup;
                } );
                var keys = Object.keys( dcc.configurator.data.json.configurables ).sort(),
                    returnObj = {};
                keys.forEach( function ( key ) {
                    returnObj[ key.replace( key.substring( 0, 2 ), '' ) ] = dcc.configurator.data.json.configurables[ key ];
                } );
                return returnObj;
            }
        },
        data: {
            defaults: {},
            json: {},
            configuration: {
                isEditing: false,
                isLeasingAllowed: false,
                leasing: {},
                autopilot: {},
                warranty: {},
                warrantyRelatedProducts: [],
                basePrice: '',
                baseBeforePrice: '',
                hasBeforePrice: false,
                price: 0,
                fee: 0,
                categories: {},
                orderlineFields: {}
            },
            init: function () {
                dcc.configurator.data.json = e4.data.get( 'dcc.configurator.data.json' );
                dcc.configurator.data.defaults.configuration = dcc.configurator.data.configuration;
                dcc.configurator.data.handleData();
            },
            handleData: function () {
                dcc.configurator.data.json.configurables = dcc.configurator.utils.cleanupConfigurationGroups();
                jQuery.each( dcc.configurator.data.json.configurables, function ( strKey, objGroup ) {
                    dcc.configurator.utils.sortPartsByPrice( objGroup.parts );
                    if ( strKey === dcc.configurator.constants.keyboardsInternal ) {
                        if ( objGroup.parts.length > 0 ) {
                            if ( objGroup.parts[ 0 ].languageParts !== undefined && objGroup.parts[ 0 ].languageParts.length > 0 ) {
                                objGroup.hasGroupedParts = true;
                                objGroup.groupedParts = objGroup.parts[ 0 ].languageParts;
                            }
                            var temKeyBoardObj = Object.assign( {}, objGroup.parts[ 0 ] );
                            objGroup.parts[ 0 ].isDefault = true;
                            objGroup.parts[ 0 ].basicKeyboard = true;
                            temKeyBoardObj.isDefault = false;
                            temKeyBoardObj.id = temKeyBoardObj.id + 'temp';
                            temKeyBoardObj.basicKeyboard = false;
                            objGroup.parts.push( temKeyBoardObj );
                            var hasDefaultLanguagePart = objGroup.parts[ 0 ].languages.filter( function ( objPart ) {
                                return objPart.isDefault === true;
                            } );
                            if ( hasDefaultLanguagePart.length === 0 ) {
                                var objClone = Object.assign( {}, objGroup.parts[ 0 ].languages[ 0 ] );
                                objClone.id = objClone.id + 'temp';
                                objClone.isDefault = true;
                                objClone.price = 0;
                                objClone.priceDiff = 0;
                                objClone.keyboardLang = objClone.defaultLanguage;
                                objGroup.parts[ 0 ].languages.unshift( objClone );
                                objGroup.languageParts.unshift( objClone );
                            }
                        }
                    }
                    var hasDefault = objGroup.parts.filter( function ( objPart ) {
                        return objPart.isDefault === true;
                    } );
                    objGroup.hasDefault = hasDefault.length > 0;
                    if ( objGroup.hasDefault === true && objGroup.isLocked === false ) {
                        objGroup.parts.forEach( function ( part, index ) {
                            if ( part.number === dcc.configurator.constants.nothingSelected ) {
                                objGroup.parts.splice( index, 1 );
                                if ( strKey === dcc.configurator.constants.keyboardsInternal ) {
                                    objGroup.parts.push( hasDefault[ 0 ] );
                                }
                            }
                        } );
                    }
                    else {
                        objGroup.parts.forEach( function ( part ) {
                            if ( part.number === dcc.configurator.constants.nothingSelected ) {
                                part.isDefault = true;
                            }
                            part.price = part.originalPriceObj.price;
                            part.priceFormatted = part.originalPriceObj.priceFormatted;
                            part.priceDiff = part.originalPriceObj.price;
                            part.priceDiffFormatted = part.originalPriceObj.priceFormatted;
                        } );
                    }
                } );
                var defaultWarranty = dcc.configurator.data.json.ItemDescriptionByItemRelations.filter( function ( objRelationItem ) {
                    return objRelationItem.header === dcc.configurator.constants.warranty;
                } );
                if ( dcc.configurator.data.json.warrantyRelatedProducts.length > 0 ) {
                    if ( defaultWarranty.length > 0 ) {
                        dcc.configurator.data.json.warrantyRelatedProducts.unshift( {
                            id: 'x',
                            name: defaultWarranty[ 0 ].value,
                            number: 'x',
                            intPrice: dcc.configurator.overview.price.formatPrice( 0, 0 ).intPrice,
                            strPrice: dcc.configurator.overview.price.formatPrice( 0, 0 ).strPrice,
                            shortDescription: defaultWarranty[ 0 ].value
                        } );
                    }
                    else {
                        dcc.configurator.data.json.warrantyRelatedProducts.unshift( {
                            id: 'x',
                            name: 'Intet valgt',
                            number: 'x',
                            intPrice: dcc.configurator.overview.price.formatPrice( 0, 0 ).intPrice,
                            strPrice: dcc.configurator.overview.price.formatPrice( 0, 0 ).strPrice,
                            shortDescription: ''
                        } );
                    }
                }
                jQuery( dcc.configurator.selectors.section ).trigger( dcc.configurator.event.dataready );
            }
        },
        observers: {
            useFee: '',
            domReady: function () {
                jQuery( dcc.configurator.selectors.section ).trigger( dcc.configurator.event.domready );
            },
            configurationObserver: function () {
                dcc.configurator.observers.changedInstances = [];
                dcc.configurator.observers.RAMInstances = {
                    category: null,
                    max: 0,
                    combined: 0,
                    partRAM: []
                };
                jQuery( dcc.configurator.selectors.categoryContainer ).each( function ( index, category ) {
                    var containerDefaultConfiguration = dcc.configurator.utils.getPartDefaultConfiguration( category ),
                        containerSelectedConfiguration = dcc.configurator.utils.getPartConfiguration( category ),
                        containerRAM = dcc.configurator.utils.getPartRAM( category );
                    if ( containerRAM !== undefined ) {
                        dcc.configurator.observers.RAMInstances.category = category;
                        dcc.configurator.observers.RAMInstances.max = containerRAM.maxRam;
                        dcc.configurator.observers.RAMInstances.combined += containerRAM.partRam;
                        dcc.configurator.observers.RAMInstances.partRAM.push( containerRAM.partRam );
                    }
                    //console.log( 'containerDefaultConfiguration - debug', containerDefaultConfiguration );
                    //console.log( 'containerSelectedConfiguration', containerSelectedConfiguration );
                    if ( containerDefaultConfiguration !== undefined && containerSelectedConfiguration !== 'none' ) {
                        if ( containerDefaultConfiguration !== containerSelectedConfiguration ) {
                            dcc.configurator.observers.changedInstances.push( category );
                        }
                    }
                } );
                dcc.configurator.observers.defaultsObserver();
                dcc.configurator.observers.RAMObserver();
            },
            defaultsObserver: function () {
                if ( dcc.configurator.observers.changedInstances.length < 2 ) {
                    dcc.configurator.observers.useFee = dcc.configurator.constants.supportPrice;
                }
                else if ( dcc.configurator.observers.changedInstances.length > 1 ) {
                    dcc.configurator.observers.useFee = dcc.configurator.constants.combinedSupportPrice;
                }
                else {
                    dcc.configurator.observers.useFee = '';
                }
            },
            RAMObserver: function () {
                var freeRAMLeft = dcc.configurator.observers.RAMInstances.max - dcc.configurator.observers.RAMInstances.combined,
                    categorySlots = jQuery( dcc.configurator.observers.RAMInstances.category ).data(),
                    ramCategories = jQuery( dcc.configurator.selectors.categoryContainer ).filter( '[data-slot="MEMORY"]' ),
                    selectedRamArr = dcc.configurator.utils.getSelectedRAMSlots();
                if ( categorySlots !== undefined && ramCategories.length > 1 ) {
                    ramCategories.each( function ( categoryIndex, category ) {
                        jQuery( category ).find( dcc.configurator.selectors.partInput ).each( function ( partIndex, domInput ) {
                            if ( jQuery( domInput ).is( dcc.configurator.selectors.partInputNone ) === true ) {
                                return;
                            }
                            var dataRAM = jQuery( domInput ).data( 'ram' );
                            if ( selectedRamArr[ categoryIndex ] !== dataRAM && parseInt( dataRAM ) > freeRAMLeft ) {
                                jQuery( domInput ).prop( 'disabled', true );
                            }
                            else {
                                jQuery( domInput ).prop( 'disabled', false );
                            }
                        } );
                    } );
                }
            },
            statesObserver: function () {
                if ( e4.util.hash.get( 'state' ) === dcc.configurator.states.config ) {
                    dcc.configurator.utils.tabs( 'dcc-productpage-tab-config', true );
                }
                if ( e4.util.hash.get( 'state' ) === dcc.configurator.states.cart ) {
                    //dcc.configurator.overview.cart.load( dcc.configurator.overview.cart.build );
                    //dcc.configurator.overview.cart.relatedProducts.load();
                    jQuery( '.js-dcc-configurator-cart' ).removeClass( dcc.configurator.selectors.cssUtils.hide );
                }
                else {
                    jQuery( '.js-dcc-configurator-cart' ).addClass( dcc.configurator.selectors.cssUtils.hide );
                }
                if ( location.search.substring( 1 ).length > 0 ) {
                    var paramGroups = location.search.substring( 1 ).split( '&' );
                    for ( var i = 0; i < paramGroups.length; i++ ) {
                        var urlParamPair = paramGroups[ i ].split( '=' );
                        if ( urlParamPair[ 0 ] === 'edit' && urlParamPair[ 1 ] === 'true' ) {
                            dcc.configurator.data.configuration.isEditing = true;
                        }
                        else if ( urlParamPair[ 0 ] === 'ol' ) {
                            dcc.configurator.editConfiguration.orderlineId = urlParamPair[ 1 ];
                        }
                    }
                }
                jQuery( dcc.configurator.selectors.section ).trigger( dcc.configurator.event.stateready );
            }
        },
        editConfiguration: {
            orderlineId: '',
            warrantyOrderlineId: '',
            latestOrerlinerData: {},
            init: function () {
                if ( dcc.configurator.data.configuration.isEditing === true && dcc.configurator.editConfiguration.orderlineId !== '' ) {
                    dcc.configurator.overview.cart.load( dcc.configurator.editConfiguration.getEditableOrderline );
                }
            },
            getEditableOrderline: function ( data ) {
                var editableOrderline = data.cart.orderlines.filter( function ( objOrderline ) {
                    return objOrderline.id === dcc.configurator.editConfiguration.orderlineId;
                } );
                if ( editableOrderline.length > 0 ) {
                    var warrantyOrderline = data.cart.orderlines.filter( function ( objOrderline ) {
                        return objOrderline.product.orderlineFields.Warranty_Parent_Product === editableOrderline[ 0 ].product.id;
                    } );
                    dcc.configurator.editConfiguration.update( editableOrderline[ 0 ], warrantyOrderline[ 0 ] );
                }
            },
            update: function ( objOrderline, objWarrantyOrderline ) {
                dcc.configurator.editConfiguration.setMainValues( objOrderline );
                dcc.configurator.editConfiguration.setWarranty( objWarrantyOrderline );
                objOrderline.product.orderlineBOMItems.forEach( function ( objBomItem ) {
                    dcc.configurator.editConfiguration.setBomItem( objBomItem );
                } );
                dcc.configurator.editConfiguration.setLeasing( objOrderline.product.orderlineFields );
                dcc.configurator.editConfiguration.setAutopilot( objOrderline.product.orderlineFields );
                dcc.configurator.utils.tabs( 'dcc-productpage-tab-config', true );
                var intScrollTarget = e4.scrollToAnchor.getTarget( '#dcc-productpage-tab-config' );
                jQuery( 'html,body' ).animate( {
                    scrollTop: intScrollTarget
                }, Math.floor( Math.abs( jQuery( window ).scrollTop() - intScrollTarget ) * e4.settings.scrollToAnchor.speed ), e4.settings.scrollToAnchor.easing );
            },
            setMainValues: function ( objOrderline ) {
                setTimeout( function () {
                    jQuery( dcc.configurator.selectors.quantity ).val( objOrderline.quantity );
                }, 10 );
            },
            setBomItem: function ( bomItem ) {
                var slotName = bomItem.bomOrderlineFields.SlotName;
                if ( slotName !== undefined ) {
                    var categoryContainer = jQuery( dcc.configurator.selectors.categoryContainer + '[data-edit-slot="' + slotName.toLowerCase() + '"]' );
                    if ( categoryContainer.length > 0 ) {
                        var bomItemInput = categoryContainer.find( dcc.configurator.selectors.partInput + '[value="' + bomItem.id + '"]' );
                        if ( bomItemInput.length > 0 ) {
                            bomItemInput.prop( 'checked', true ).trigger( 'change' );
                        }
                        else {
                            var bomItemSelect = categoryContainer.find( dcc.configurator.selectors.partSelect ).filter( function ( domElm ) {
                                return jQuery( domElm ).find( 'option[value="' + bomItem.id + '"]' );
                            } );
                            bomItemSelect.val( bomItem.id ).trigger( 'change' );
                        }
                        if ( bomItem.number === dcc.configurator.constants.osOtherLang ) {
                            var customInput = bomItemInput.closest( dcc.configurator.selectors.categoryItem ).find( dcc.configurator.selectors.partOsLanguageInput );
                            if ( customInput.length > 0 ) {
                                var customLang = bomItem.bomOrderlineFields.OSLanguageCustom;
                                customInput.val( customLang ).trigger( 'input' );
                            }
                        }
                    }
                }
            },
            setWarranty: function ( objWarrantyOrderline ) {
                if ( objWarrantyOrderline ) {
                    dcc.configurator.overview.warranty.isOpen = true;
                    dcc.configurator.editConfiguration.warrantyOrderlineId = objWarrantyOrderline.id;
                    jQuery( dcc.configurator.selectors.warranty.input ).filter( '[value="' + objWarrantyOrderline.product.id + '"]' ).prop( 'checked', true ).trigger( 'change' );
                }
            },
            setLeasing: function ( objLeasingDetails ) {
                if ( objLeasingDetails.Leasing_checked === 'true' ) {
                    dcc.configurator.overview.leasing.model.open = true;
                    jQuery( dcc.configurator.selectors.leasing.checkbox ).prop( 'checked', true );
                    jQuery( dcc.configurator.selectors.leasing.selectRate ).val( objLeasingDetails.Leasing_price ).trigger( 'change' );
                }
            },
            setAutopilot: function ( objLeasingDetails ) {
                if ( objLeasingDetails.Autopilot_checked === 'true' ) {
                    dcc.configurator.overview.autopilot.model.open = true;
                    dcc.configurator.overview.autopilot.model.checked = true;
                    jQuery( dcc.configurator.selectors.autopilot.checkbox ).prop( 'checked', true );
                    jQuery( dcc.configurator.selectors.autopilot.email ).val( objLeasingDetails[dcc.configurator.constants.autopilotEmailOrderlineFieldSystemName] ).trigger( 'change' );
                }
            },
            setOsLang: function () {
            },
            reset: function () {
                dcc.configurator.data.configuration.isEditing = false;
                dcc.configurator.editConfiguration.orderlineId = '';
                dcc.configurator.editConfiguration.warrantyOrderlineId = '';
                history.pushState( null, null, location.href.replace( location.search, '' ) );
            }
        },
        list: {
            init: function () {
                dcc.configurator.list.build();
                dcc.configurator.list.priceDiff.init();
            },
            build: function () {
                jQuery.each( dcc.configurator.data.json.configurables, function ( key ) {
                    dcc.configurator.data.json.configurables[ key ].parts = dcc.configurator.utils.sortByDefault( dcc.configurator.data.json.configurables[ key ].parts );
                } );
                jQuery( dcc.configurator.selectors.partsContainer ).html( e4.handlebars.tmpl.configuratorParts( dcc.configurator.data.json ) );
                jQuery( dcc.configurator.selectors.section ).trigger( dcc.configurator.event.listbuild );
            },
            reset: function () {
                dcc.configurator.list.build();
                dcc.configurator.list.priceDiff.init();
            },
            priceDiff: {
                init: function () {
                    jQuery( dcc.configurator.selectors.categoryContainer ).each( function ( index, container ) {
                        dcc.configurator.list.priceDiff.update( container );
                    } );
                },
                update: function ( domElm ) {
                    /*var priceFormat = '<span class="e-price-currency e-price-currency-code">' + dcc.configurator.data.json.prices.currencyCode + '</span>';*/
                    jQuery( domElm ).find( dcc.configurator.selectors.partInput ).each( function ( index, input ) {
                        if ( jQuery( input ).is( dcc.configurator.selectors.partInputNone ) === true ) {
                            return;
                        }
                        var partCategory = jQuery( input ).data( 'category' ),
                            partId = jQuery( input ).data( 'id' ),
                            partObj = dcc.configurator.utils.getPartObj( partCategory, partId ),
                            jDiffPriceElm = jQuery( input ).parent().find( dcc.configurator.selectors.diffPrice ),
                            pricePrefix = dcc.configurator.overview.price.getPricePrefix( partObj.priceDiff );
                        if ( jDiffPriceElm.is( dcc.configurator.selectors.partIdDefault ) === false ) {
                            jDiffPriceElm.html( '<span>' + pricePrefix + e4.util.formatJavascriptNumberToLocaleString( partObj.priceDiff ) + '</span>' );
                        }
                    } );
                }
            }
        },
        main: {
            update: function ( strPrice ) {
                var jMainPrice = jQuery( '.js-dcc-configuration-main-price' );
                if ( strPrice === undefined ) {
                    strPrice = jMainPrice.data( 'basePrice' );
                    jMainPrice.html( strPrice );
                } else{
                    jMainPrice.find( '.e-price-price' ).text( strPrice );
                }
                
            }
        },
        overview: {
            init: function () {
                dcc.configurator.data.configuration.basePrice = e4.util.formatJavascriptNumberToLocaleString( dcc.configurator.data.json.prices.basePrice );
                dcc.configurator.data.configuration.hasBeforePrice = dcc.configurator.data.json.prices.beforePrice > 0;
                dcc.configurator.data.configuration.baseBeforePrice = dcc.configurator.data.json.prices.beforePriceFormatted;
                dcc.configurator.data.configuration.warrantyRelatedProducts = dcc.configurator.data.json.warrantyRelatedProducts;
                dcc.configurator.overview.build( dcc.configurator.observers.domReady );
                dcc.configurator.overview.update();
            },
            update: function () {
                dcc.configurator.data.configuration.price = dcc.configurator.overview.price.calculatePrice();
                dcc.configurator.data.configuration.hasConfiguration = dcc.configurator.overview.hasConfiguration();
                dcc.configurator.data.configuration.isLeasingAllowed = dcc.configurator.data.json.isLeasingAllowed;
                dcc.configurator.data.configuration.categories = dcc.configurator.overview.categories.update();
                //console.log(dcc.configurator.data.configuration.hasConfiguration);
                if ( dcc.configurator.data.configuration.hasConfiguration === true || dcc.configurator.data.configuration.hasChanged === true) {
                    dcc.configurator.main.update( dcc.configurator.data.configuration.price.strPrice );
                } else{
                    dcc.configurator.main.update();
                }
                
                dcc.configurator.overview.build();
            },
            reset: function () {
                dcc.configurator.data.configuration = dcc.configurator.data.defaults.configuration;
                dcc.configurator.list.reset();
                dcc.configurator.data.configuration.basePrice = e4.util.formatJavascriptNumberToLocaleString( dcc.configurator.data.json.prices.basePrice );
                dcc.configurator.data.configuration.hasBeforePrice = dcc.configurator.data.json.prices.beforePrice > 0;
                dcc.configurator.data.configuration.baseBeforePrice = dcc.configurator.data.json.prices.beforePriceFormatted;
                dcc.configurator.data.configuration.warrantyRelatedProducts = dcc.configurator.data.json.warrantyRelatedProducts;
                dcc.configurator.overview.update();
            },
            build: function ( fnCallback, forceQuantity ) {
                dcc.configurator.overview.setQuantity( forceQuantity );
                jQuery( dcc.configurator.selectors.overviewContainer ).html( e4.handlebars.tmpl.configuratorOverview( dcc.configurator.data.configuration ) );
                jQuery( dcc.configurator.selectors.mobileHandlerPrice ).html( dcc.configurator.data.configuration.price.strPrice );
                jQuery( dcc.configurator.selectors.section ).trigger( dcc.configurator.event.overviewbuild );
                jQuery( '[data-toggle="tooltip"]' ).tooltip();
                dcc.configurator.overview.leasing.price();
                if ( typeof fnCallback === 'function' ) {
                    fnCallback();
                }
            },
            setQuantity: function ( forceQuantity ) {
                var productQuantity = jQuery( '.js-e-product-form' ).find( 'input[name="Quantity"]' ).val(),
                    configuratorQuantity = jQuery( dcc.configurator.selectors.quantity ).val();
                if ( forceQuantity !== true ) {
                    dcc.configurator.data.configuration.quantity = configuratorQuantity !== '' ? configuratorQuantity : 1;
                }
                else {
                    dcc.configurator.data.configuration.quantity = productQuantity;
                }
            },
            hasConfiguration: function () {
                var returnValue = false;
                if ( typeof dcc.configurator.observers.changedInstances !== 'undefined' ) {
                    returnValue = dcc.configurator.observers.changedInstances.length > 0;
                }
                if ( Object.keys( dcc.configurator.data.configuration.warranty ).length > 0 ) {
                    returnValue = dcc.configurator.data.configuration.warranty.selectedValue.length > 0;
                }
                return returnValue;
            },
            categories: {
                update: function () {
                    //console.log( '-- Update --' );
                    var jSelectedParts = dcc.configurator.utils.getSelectedParts(),
                        objItems = {};
                    jSelectedParts.each( function ( index, domElm ) {
                        var boolIsNoneInput = jQuery( domElm ).is( dcc.configurator.selectors.partInputNone ),
                            strPartCategory = jQuery( domElm ).data( 'category' ),
                            strPartId = jQuery( domElm ).data( 'id' ),
                            objItem = {},
                            objCategory = dcc.configurator.utils.getCategoryObj( strPartCategory );
                        if ( boolIsNoneInput === false ) {
                            if ( strPartCategory === dcc.configurator.constants.keyboardsInternal ) {
                                var strSelectedLanguageProductId = jQuery( domElm ).closest( dcc.configurator.selectors.categoryContainer ).find( dcc.configurator.selectors.partSelect ).val();
                                objItem = dcc.configurator.utils.getLanguagePartObj( strPartCategory, strSelectedLanguageProductId );
                            }
                            else {
                                objItem = dcc.configurator.utils.getPartObj( strPartCategory, strPartId );
                            }
                            objItems[ strPartCategory ] = objItems[ strPartCategory ] || {};
                            objItems[ strPartCategory ].id = objCategory.bomId;
                            objItems[ strPartCategory ].key = objCategory.id;
                            objItems[ strPartCategory ].label = objCategory.label;
                            if ( strPartCategory === dcc.configurator.constants.keyboardsInternal ) {
                                objItems[ strPartCategory ].parts = objItems[ strPartCategory ].groupedParts || [];
                            }
                            else {
                                objItems[ strPartCategory ].parts = objItems[ strPartCategory ].parts || [];
                            }
                            if ( strPartCategory === dcc.configurator.constants.oslanguage ) {
                                objItems[ strPartCategory ].partOsLanguage = jQuery( dcc.configurator.selectors.partOsLanguageInput ).val();
                            }
                            objItems[ strPartCategory ].parts.push( objItem );
                        }
                    } );
                    return objItems;
                }
            },
            price: {
                formatPrice: function ( intPrice, intSupportPrice ) {
                    var strServiceFeePrefix = dcc.configurator.overview.price.getPricePrefix( intSupportPrice );
                    return {
                        strPrice: e4.util.formatJavascriptNumberToLocaleString( intPrice ),
                        intPrice: intPrice,
                        strSupportPrice: strServiceFeePrefix + e4.util.formatJavascriptNumberToLocaleString( intSupportPrice ),
                        intSupportPrice: intSupportPrice
                    };
                },
                calculatePrice: function () {
                    var intTotalPrice = e4.util.formatStringToJavascriptNumber( dcc.configurator.data.json.prices.basePrice ),
                        intWarrantyPrice = dcc.configurator.overview.warranty.getPrice(),
                        jSelectedParts = dcc.configurator.utils.getSelectedParts(),
                        intSupportPrice = 0,
                        intArrCombinedPrices = [];
                    jSelectedParts.each( function ( index, domElm ) {
                        var boolIsNoneInput = jQuery( domElm ).is( dcc.configurator.selectors.partInputNone ),
                            strPartCategory = jQuery( domElm ).data( 'category' ),
                            strPartId = jQuery( domElm ).data( 'id' ),
                            partObj = dcc.configurator.utils.getPartObj( strPartCategory, strPartId );
                        if ( boolIsNoneInput === false ) {
                            if ( strPartCategory === dcc.configurator.constants.keyboardsInternal ) {
                                var strSelectedLanguageProductId = jQuery( domElm ).closest( dcc.configurator.selectors.categoryContainer ).find( dcc.configurator.selectors.partSelect ).val();
                                partObj = dcc.configurator.utils.getLanguagePartObj( strPartCategory, strSelectedLanguageProductId );
                            }
                            if ( partObj.isDefault === false && dcc.configurator.observers.useFee !== '' ) {
                                if ( dcc.configurator.observers.useFee === dcc.configurator.constants.supportPrice ) {
                                    intSupportPrice += partObj.supportPrice;
                                }
                                else if ( dcc.configurator.observers.useFee === dcc.configurator.constants.combinedSupportPrice ) {
                                    intArrCombinedPrices.push( partObj.combinedSupportPrice );
                                    intSupportPrice = intArrCombinedPrices.reduce( function ( a, b ) {
                                        return Math.max( a, b );
                                    } );
                                }
                            }
                            intTotalPrice += e4.util.formatStringToJavascriptNumber( partObj.priceDiff );
                        }
                    } );
                    intTotalPrice += dcc.configurator.overview.autopilot.model.intPrice;
                    intTotalPrice += e4.util.formatStringToJavascriptNumber( ( intSupportPrice + intWarrantyPrice ) );
                    return dcc.configurator.overview.price.formatPrice( intTotalPrice, intSupportPrice );
                },
                getPricePrefix: function ( intPrice ) {
                    var pricePrefix = '+';
                    if ( intPrice <= 0 ) {
                        pricePrefix = '';
                    }
                    return pricePrefix;
                },
                updateKeyboardPrice: function ( domElm ) {
                    var dataObj = dcc.configurator.utils.getLanguagePartObj( dcc.configurator.constants.keyboardsInternal, domElm.value ),
                        pricePrefix = dcc.configurator.overview.price.getPricePrefix( dataObj.priceDiff );
                    jQuery( domElm ).closest( dcc.configurator.selectors.categoryItem ).find( dcc.configurator.selectors.diffPriceKeyboard ).text( pricePrefix + e4.util.formatJavascriptNumberToLocaleString( dataObj.priceDiff ) );
                }
            },
            mobile: {
                toggle: function () {
                    jQuery( dcc.configurator.selectors.overview ).toggleClass( dcc.configurator.selectors.cssUtils.open );
                    jQuery( dcc.configurator.selectors.mobileHandle ).toggleClass( dcc.configurator.selectors.cssUtils.open );
                }
            },
            autopilot: {
                model: {
                    intPrice: 0,
                    strPrice: '',
                    checked: false,
                    open: false,
                    email: ''
                },
                update: function(isChecked){
                    dcc.configurator.overview.autopilot.model.checked = isChecked;
                    dcc.configurator.overview.autopilot.model.intPrice = isChecked ? e4.util.formatStringToJavascriptNumber(jQuery(dcc.configurator.selectors.autopilot.checkbox).data('price')) : 0;
                    dcc.configurator.overview.autopilot.model.strPrice = isChecked ? e4.util.formatJavascriptNumberToLocaleString(jQuery(dcc.configurator.selectors.autopilot.checkbox).data('price')) : '';
                    dcc.configurator.overview.autopilot.model.email = isChecked ? jQuery(dcc.configurator.selectors.autopilot.emailValue).val() : '';
                    dcc.configurator.data.configuration.autopilot = dcc.configurator.overview.autopilot.model;
                    dcc.configurator.overview.update();
                }
            },
            leasing: {
                model: {
                    rate: '',
                    price: '',
                    checked: false,
                    open: false
                },
                init: function () {
                    dcc.configurator.overview.leasing.price();
                },
                price: function () {
                    jQuery( dcc.configurator.selectors.leasing.price ).html( jQuery( dcc.configurator.selectors.leasing.selectRate ).val() );
                    dcc.configurator.overview.leasing.offer();
                },
                offer: function () {
                    var isChecked = jQuery( dcc.configurator.selectors.leasing.checkbox ).is( ':checked' );
                    //console.log( 'leasing checked', isChecked );
                    if ( isChecked === true ) {
                        dcc.configurator.overview.leasing.set();
                    }
                    else {
                        dcc.configurator.overview.leasing.reset();
                    }
                    dcc.configurator.overview.leasing.model.checked = isChecked;
                    dcc.configurator.data.configuration.leasing.checked = isChecked;
                    jQuery( dcc.configurator.selectors.leasing.checked ).val( isChecked );
                    dcc.configurator.overview.leasing.update();
                },
                set: function () {
                    var strRate = jQuery( dcc.configurator.selectors.leasing.selectRate + ' option:selected' ).text(),
                        strLeasingPrice = jQuery( dcc.configurator.selectors.leasing.price ).text();
                    dcc.configurator.overview.leasing.model.rate = strRate;
                    dcc.configurator.overview.leasing.model.price = strLeasingPrice;
                    jQuery( dcc.configurator.selectors.leasingInputRate ).val( strRate );
                    jQuery( dcc.configurator.selectors.leasing.inputRate ).val( strLeasingPrice );
                },
                reset: function () {
                    dcc.configurator.overview.leasing.model.rate = '';
                    dcc.configurator.overview.leasing.model.price = '';
                    jQuery( dcc.configurator.selectors.leasingInputRate ).val( '' );
                    jQuery( dcc.configurator.selectors.leasing.inputRate ).val( '' );
                },
                update: function () {
                    dcc.configurator.data.configuration.leasing = dcc.configurator.overview.leasing.model;
                }
            },
            warranty: {
                isOpen: false,
                selectedValue: '',
                update: function ( domElm ) {
                    dcc.configurator.overview.warranty.selectedValue = domElm.value;
                    dcc.configurator.data.configuration.warranty = {
                        isOpen: dcc.configurator.overview.warranty.isOpen,
                        selectedValue: dcc.configurator.overview.warranty.selectedValue,
                        data: dcc.configurator.utils.getSelectedWarranty()
                    };
                },
                getPrice: function () {
                    var checkedWarrantyInput = jQuery( dcc.configurator.selectors.partsContainer ).find( dcc.configurator.selectors.warranty.input ).filter( ':checked' );
                    return checkedWarrantyInput.length > 0 ? checkedWarrantyInput.data( 'price' ) : 0;
                }
            },
            cart: {
                load: function ( fnCallback ) {
                    e4.cart.ajax( {
                        method: 'GET'
                    }, function ( data ) {
                        if ( typeof fnCallback === 'function' ) {
                            fnCallback( data );
                        }
                    } );
                },
                update: function ( orderlineId ) {
                    e4.cart.ajax( {
                        data: {
                            key: orderlineId,
                            CartCmd: 'delorderline',
                            Redirect: false
                        }
                    }, function () {
                        if ( dcc.configurator.editConfiguration.warrantyOrderlineId !== '' ) {
                            dcc.configurator.overview.cart.update( dcc.configurator.editConfiguration.warrantyOrderlineId );
                            dcc.configurator.editConfiguration.reset();
                        }
                        else {
                            dcc.configurator.editConfiguration.reset();
                            dcc.configurator.overview.update();
                            dcc.configurator.overview.cart.add();
                        }
                    } );
                },
                add: function () {
                    jQuery( dcc.configurator.selectors.section ).trigger( dcc.configurator.event.addtocart );
                    var formData = jQuery( dcc.configurator.selectors.form ).serializeArray(),
                        formDataJson = {};
                    jQuery.map( formData, function ( input ) {
                        formDataJson[ input[ 'name' ] ] = input[ 'value' ];
                    } );
                    e4.cart.ajax( {
                        beforeSend: function () {
                            dcc.configurator.utils.loader( true );
                            //jQuery( dcc.configurator.selectors.section ).collapse( 'hide' );
                        },
                        data: formDataJson
                    }, function ( data ) {
                        var selectedWarrantyProductObj = dcc.configurator.utils.getSelectedWarranty();
                        if ( selectedWarrantyProductObj !== undefined ) {
                            dcc.configurator.overview.cart.addWarranty( selectedWarrantyProductObj );
                        }
                        else {
                            dcc.configurator.overview.cart.build( data );
                        }
                    } );
                },
                addWarranty: function ( selectedWarrantyProductObj ) {
                    e4.cart.ajax( {
                        data: {
                            cartcmd: 'add',
                            redirect: false,
                            productid: selectedWarrantyProductObj.id,
                            variantid: '',
                            unitid: '',
                            quantity: jQuery( dcc.configurator.selectors.quantity ).val(),
                            EcomOrderLineFieldInput_Warranty_Parent_Product: jQuery( dcc.configurator.selectors.warranty.orderLineField ).val()
                        }
                    }, function ( data ) {
                        dcc.configurator.overview.cart.build( data );
                    } );
                },
                build: function ( data ) {
                    e4.cart.msg.show( data, true );
                    e4.cart.updateQuantity( data.cart.productQuantity );
                    e4.util.hash.set( 'state', dcc.configurator.states.cart );
                    jQuery( '#dcc-productpage-tab-accessories' ).tab( 'show' );
                    dcc.configurator.overview.reset();
                    dcc.configurator.utils.loader( false );
                }
            }
        },
        related: {
            hide: function () {
                jQuery( dcc.configurator.selectors.relatedProducts ).addClass( dcc.configurator.selectors.cssUtils.totalCollapse );
            },
            show: function () {
                jQuery( dcc.configurator.selectors.relatedProducts ).removeClass( dcc.configurator.selectors.cssUtils.totalCollapse );
            }
        }
    };
}() );
